module.exports = __webpack_public_path__ + "img/11.a6396951.jpg";